import { render, staticRenderFns } from "./page-header.vue?vue&type=template&id=caaadd6c&scoped=true&"
import script from "./page-header.vue?vue&type=script&lang=js&"
export * from "./page-header.vue?vue&type=script&lang=js&"
import style0 from "./page-header.vue?vue&type=style&index=0&id=caaadd6c&lang=scss&scoped=true&"
import style1 from "./page-header.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caaadd6c",
  null
  
)

export default component.exports